import { render, staticRenderFns } from "./ObiButton.vue?vue&type=template&id=b05daa90&scoped=true&"
import script from "./ObiButton.vue?vue&type=script&lang=js&"
export * from "./ObiButton.vue?vue&type=script&lang=js&"
import style0 from "./ObiButton.vue?vue&type=style&index=0&id=b05daa90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b05daa90",
  null
  
)

export default component.exports